export const handleMobileKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.ctrlKey || e.metaKey || e.altKey) {
    return;
  }

  if (e.key.length > 1) {
    return;
  }

  if (/^[0-9+]$/.test(e.key)) {
    return;
  }

  e.preventDefault();
};
